//libs
import {Component} from "react";
import React from "react";
import {connect} from 'react-redux';
import PropTypes from "prop-types";
//components
import Sidebar from "../Sidebar";

class PageWithSidebar extends Component {

  static propTypes = {
    /** page class to seperate different pages */
    page: PropTypes.string,
    isOpen: PropTypes.bool
  };

  static defaultProps = {
    page: ""
  };


  render() {

    let sidebarClass="";
    if (!this.props.isOpen){
      sidebarClass = " sidebar--collapsed";
    }

    return (
      <div>
        <div className={"main-content-width-sidebar "+this.props.page+sidebarClass} >
          <div className={"main-content-width-sidebar-inner "+this.props.page+"-inner"} >
            {this.props.children}
          </div>
        </div>
        <Sidebar location={this.props.location} />
      </div>
    );

  }
}

/**
 * Map actions to properties
 */
const mapStateToProps = (state) => ({
  isOpen: state.sidebar.isOpen
});

export default connect(mapStateToProps)(PageWithSidebar)


// WEBPACK FOOTER //
// ./src/components/Layouts/PageWithSidebar.js